import axios from 'axios';
import config from '../../constants/apiConfig';
import type { IapFormId } from 'components/IAP/iapAttachmentManifest';

export type ExportPaginatedIapDeps = {
  incident: unknown;
  user: unknown;
  groupGuid: string;
  /** Download / display stem (incident name + " IAP") */
  formnameStem: string;
  mapSketch?: any;
};

/** A selected file whose pages could not be appended, and why. */
export type OmittedIapAttachment = {
  fileId: string;
  label: string;
  reason: string;
};

type ExportPaginatedIapResponse = {
  pdfBase64: string;
  includedForms: IapFormId[];
  omittedForms: IapFormId[];
  omittedAttachments: OmittedIapAttachment[];
};

export async function postExportPaginatedIap(
  deps: ExportPaginatedIapDeps,
  periodNumber?: number | null
): Promise<{
  downloadStem: string;
  data: string;
  includedForms: IapFormId[];
  /** Selected forms that had nothing to render, so are absent from the bundle. */
  omittedForms: IapFormId[];
  /** Selected files whose pages could not be appended. */
  omittedAttachments: OmittedIapAttachment[];
}> {
  const formData = new FormData();
  formData.append('formname', deps.formnameStem);
  formData.append('incident', JSON.stringify(deps.incident));
  formData.append('user', JSON.stringify(deps.user));
  formData.append('groupGuid', deps.groupGuid);
  if (periodNumber != null) {
    formData.append('operationalPeriod', JSON.stringify(periodNumber));
  }
  if (deps.mapSketch != null) {
    formData.append('file', deps.mapSketch);
  }

  const response = await axios.post<ExportPaginatedIapResponse>(
    config.apiGateway.exportPaginatedIAP,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );

  return {
    downloadStem: deps.formnameStem,
    data: response.data?.pdfBase64 || '',
    includedForms: response.data?.includedForms ?? [],
    omittedForms: response.data?.omittedForms ?? [],
    omittedAttachments: response.data?.omittedAttachments ?? [],
  };
}
